import type { Deal } from "~/models/Deal";
import Styles from "./DealFileCard.module.scss";

type Props = {
	deal: Deal;
	hasInspectionFile: boolean;
	inspectionFilePath: string;
};

export function LeasingInspectionFileCard({
	deal,
	hasInspectionFile,
	inspectionFilePath
}: Props) {
	return (
		<div className={Styles.DealCard}>
			<h3 className={Styles.Title}>現況確認報告書</h3>
			<div className={Styles.FileList}>
				<div className={Styles.FileRow}>
					<div className={Styles.FileContent}>
						{hasInspectionFile ? (
							<a
								className={Styles.FileLink}
								href={inspectionFilePath}
								rel="noreferrer"
								target="_blank"
							>
								{deal.name}_{deal.roomNumber}_現況確認報告書.pdf
							</a>
						) : (
							<div className={Styles.NoFile}>ファイル登録なし</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
